/**
 * Exit – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Exit app icon. */
export default function ExitIcon({ focused, height, width }: Props) {
  const color = Colors['menu']['icon'][focused ? 'focused' : 'unfocused'];
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || 24 * Screen.widthRatio}
      height={height || 24 * Screen.widthRatio}
      viewBox={'0 0 24 24'}
      fill='none'
    >
      <path
        d='M22.4902 0.0488281C23.0422 0.0490531 23.49 0.496874 23.4902 1.04883V22.4912C23.49 23.0431 23.0422 23.491 22.4902 23.4912H11.7695C11.2174 23.4912 10.7698 23.0433 10.7695 22.4912V18.4707C10.7698 17.9186 11.2174 17.4707 11.7695 17.4707C12.3215 17.4709 12.7693 17.9187 12.7695 18.4707V21.4912H21.4902V2.04883H12.7695V5.06934C12.7695 5.62141 12.3216 6.06911 11.7695 6.06934C11.2173 6.06934 10.7696 5.62155 10.7695 5.06934V1.04883C10.7698 0.496735 11.2174 0.0488281 11.7695 0.0488281H22.4902ZM4.36133 7.04297C4.75179 6.65257 5.38487 6.65266 5.77539 7.04297C6.16568 7.43349 6.16579 8.06657 5.77539 8.45703L3.46289 10.7705H17.1299C17.682 10.7707 18.1299 11.2183 18.1299 11.7705C18.1297 12.3226 17.6819 12.7704 17.1299 12.7705H3.46289L5.77539 15.084C6.16568 15.4745 6.16579 16.1076 5.77539 16.498C5.38491 16.8882 4.75175 16.8882 4.36133 16.498L0.34082 12.4775C0.153476 12.2901 0.0489077 12.0355 0.0488281 11.7705C0.0488281 11.5055 0.153497 11.251 0.34082 11.0635L4.36133 7.04297Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 0.8 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  );
}
